import { Inject, Injectable } from "@angular/core";
import { tap, catchError, map, Observable } from "rxjs";
import IDisplayModules from "../domain/ports/display/i-display-modules";
import IManageModules from "../domain/ports/manage/i-manage-modules";
import { CreateModuleDTO, ModuleItem, UpdateModuleDTO } from "../domain/models/moduleItem";
import { ApiResponse, PaginatedData } from "../domain/models/apiResponse";
import ErrorsHandler from "./errors-handler";
import IManageMessages from "./ports/i-manage-messages";

@Injectable()
export class ModulesDisplayer implements IDisplayModules {
  modules: ModuleItem[] = [];

  constructor(
    private _errorHandler: ErrorsHandler,
    @Inject('IManageModules') private _modulesManager: IManageModules,
    @Inject('IManageMessages') private _messagesManager: IManageMessages,
  ) {}

    getModulesList(pageIndex: number = 1, pageSize: number = 10): Observable<ApiResponse<PaginatedData<ModuleItem>>> {
        return this._modulesManager.getModules(pageIndex, pageSize).pipe(
            tap(_ => this._messagesManager.add("Fetched modules")),
            catchError(this._errorHandler.handleError<ApiResponse<PaginatedData<ModuleItem>>>('getModulesPaged')),
            map(response => {
            this.modules = response.data.data;
            return response; 
            })
        );
    }

}
